export default __webpack_public_path__ + "static/5-fitness-8d77acecdb6285d41837d2bfcff198fe.png";